// This file was auto-generated by Fern from our API Definition.
export var ApplicationRevisionDataOutput;
(function (ApplicationRevisionDataOutput) {
    ApplicationRevisionDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(ApplicationRevisionDataOutput || (ApplicationRevisionDataOutput = {}));
